const getStyle = (rowId, isSelected = false, rowStyle = {}, ishovered) => {
    const {
        alternatingBackgroundColors,
        selectionBackgroundColor,
        verticalAlign } = rowStyle;

    const colors = alternatingBackgroundColors.split(',').map((m) => m.trim()) || '';
    let backgroundColor = '';
    if (isSelected) {
        backgroundColor = selectionBackgroundColor;
    }
    else if (colors.length > 0) {
        const colorIndex = rowId % colors.length;
        backgroundColor = colors[colorIndex];
    }

    if (ishovered) {
        backgroundColor = '#EEEEEE';
    }

    return {
        verticalAlign,
        backgroundColor,
    };
};

export default getStyle;
